// eslint-disable-next-line import/prefer-default-export
export function easeInOutCubic(t, b, c, d) {
  var cc = c - b;
  t /= d / 2;

  if (t < 1) {
    return cc / 2 * t * t * t + b;
  }

  return cc / 2 * ((t -= 2) * t * t + 2) + b;
}


//////////////////
// WEBPACK FOOTER
// ../~/antd/es/_util/easings.js
// module id = 702
// module chunks = 0